
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document/career",
      function () {
        return require("private-next-pages/document/career/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document/career"])
      });
    }
  